var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3415 6.77548C13.7415 6.22163 13.5323 5.31702 12.7261 5.12009C12.6215 5.09548 12.523 5.0524 12.4246 4.99702C11.9261 4.69548 11.7661 4.04317 12.0738 3.53856C12.6523 2.59086 11.563 1.50163 10.6154 2.08009C10.523 2.14163 10.4184 2.17856 10.3138 2.20932C9.74151 2.34471 9.1692 1.99394 9.02766 1.42779C8.7692 0.344709 7.23074 0.344709 6.96612 1.42779C6.79997 2.12317 5.99997 2.45548 5.38458 2.08009C4.43689 1.50163 3.34766 2.59086 3.92612 3.53856C3.98766 3.63086 4.02458 3.73548 4.05535 3.84009C4.19074 4.4124 3.83997 4.98471 3.27381 5.12625C2.46766 5.31702 2.25843 6.22163 2.65843 6.77548",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15381 6.15402C6.15381 7.17555 6.97843 8.00017 7.99997 8.00017C9.0215 8.00017 9.84612 7.17555 9.84612 6.15402C9.84612 5.13248 9.0215 4.30786 7.99997 4.30786C6.97843 4.30786 6.15381 5.13248 6.15381 6.15402Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 8.23393C15.3846 8.45547 15.2984 8.67085 15.1323 8.84316L12.1477 11.8278C11.8215 12.1539 11.3846 12.3324 10.923 12.3324H5.93227L3.99381 10.3939C4.01843 9.50162 4.75074 8.78777 5.6492 8.78777H10.6892C10.9415 8.78777 11.1692 8.88624 11.3292 9.05239C11.4954 9.21854 11.5938 9.44008 11.5938 9.69239C11.5938 9.71701 11.5938 9.74777 11.5938 9.77239C11.7354 9.74162 11.8707 9.67393 11.9754 9.56931L13.8892 7.65547C14.2338 7.31085 14.8246 7.28624 15.1569 7.65547C15.3107 7.82162 15.3907 8.03085 15.3907 8.24008L15.3846 8.23393Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5938 9.69238C11.5938 9.69238 11.5938 9.74777 11.5938 9.77238C11.5569 10.2339 11.163 10.597 10.6892 10.597H8.56612",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3692 13.3477L4.45535 15.2615C4.29535 15.4215 4.03073 15.4215 3.87073 15.2615L0.738427 12.1292C0.578427 11.9692 0.578427 11.7046 0.738427 11.5446L2.65227 9.63074C2.81227 9.47074 3.07073 9.47074 3.23689 9.63074L3.99997 10.3938L5.93843 12.3323L6.3692 12.7631C6.5292 12.9231 6.5292 13.1877 6.3692 13.3477Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.f04868db8e96d8733f40169cc0cfca76.svg";
export { ForwardRef as ReactComponent };